export default __webpack_public_path__ + "static/media/Nunito-Bold.bb33ef1f.ttf";